export default {
  // 知识库
  knowledge: {
    all: 'all knowledge',
    mycreate: 'I created',
    mydepartment: "my department's",
    mycollection: 'my collection',
    myinvite: 'invite me to answer',
    item: 'item',
    knowledgeClassify: 'knowledge classification',
    putQuestion: 'put questions to',
    addKnowledge: 'add knowledge',
    addKnowledge2: 'add knowledge base',
    addputQuestion: 'new questions',
    knowledgeNote: 'Inherit wisdom and inspire the future.',
    putQuestionNote: 'Ask questions and look for answers.',
    label: 'label',
    publishedIn: 'published in',
    read: 'read',
    collection: 'collection',
    praise: 'likes',
    GeAnswer: 'answers',
    answer: 'answer',
    loadMore: 'load more',
    video: 'video',
    title_empty: 'title cannot be empty',
    content_empty: 'content cannot be empty',
    classify_empty: 'classify cannot be empty',
    basicInfo: 'essential information',
    title: 'title',
    videoName: 'video name',
    videoLink: 'video address',
    videoPlaceholder: 'Please paste the external media address into the input box',
    supportTip: 'Support Tencent video, Youku, iQIYI, Tudou.',
    addVideo: 'add video',
    quote: 'quote',
    addContent: 'add content',
    classify: 'classify',
    attachment: 'attachment',
    supportExtension: 'support for extension',
    addmemo: 'new memo',
    versionManage: 'version management',
    writeAnswer: 'write an answer',
    showAll: 'show all',
    inviteAnswer: 'invited answer',
    look: 'look',
    studied: 'studied',
    study: 'study',
    answerTimeOrder: 'Sort by answer time order',
    updateTimeSort: 'Sort in update time order',
    top: 'top',
    cancelTop: 'cancel the top',
    move: 'move',
    cancelLearn: 'cancel learning',
    confirmLearn: 'confirm learning',
    liked: 'liked',
    collected: 'collected',
    on: 'on',
    answeredTheQuestion: 'answer this question',
    putUp: 'put up',
    expand: 'expand',
    learnTip:
      'If you have learned this knowledge, please click "OK" button, the system will mark your learning status, so that the administrator can query the employee\'s learning record.',
    confirmtransferknowledge: 'confirm that you want to transfer the knowledge',
    what: 'what',

    classifyManage: 'classified management',
    tagManage: 'tag management',
    dataquery: 'data query',
    filedName: 'filed name',
    name: 'name',
    dragsortTip:
      'You can sort the order of options by dragging the field name up and down with the mouse.',
    labelname: 'label name',
    nolabelyet: 'no label',
    categoryname: 'category name',
    administrator: 'administrator',
    defaultclassification: 'default classification',
    open: 'open',
    private: 'private',
    openTip: 'open (all members of the organization can see this classification)',
    privateTip: 'private (only joined members can see this category)',
    delclassTip:
      'Unrecoverable after deletion, knowledge of the category will be assigned to the default category.',
    addcategories: 'add category',
    newcategory: 'new category',
    editcategories: 'edit category',
    categoryname_empty: 'category name cannot be empty',
    categorymember_empty: 'category member cannot be empty',
    categoryadmin_empty: 'category administrator cannot be empty',
    newlabel: 'new label',
    labelname_empty: 'label name cannot be empty',
    edittab: 'edit tags',
    type: 'type',
    test: ''
  }
}
